/* eslint-disable max-params,camelcase,no-empty-function,@typescript-eslint/no-unused-vars */
import {removeUUIDsFromUrl} from "./error-log.utils";
// import Constants from 'expo-constants';

class ErrorLogService {
  private static instance: ErrorLogService | undefined;

  static getInstance(): ErrorLogService {
    if (!ErrorLogService.instance) {
      ErrorLogService.instance = new ErrorLogService();
    }

    return ErrorLogService.instance;
  }

  public logError(error: unknown, file: string, method: string, args: IArguments | any[] = [], type: 'function' | 'data' = 'function', errorShown: boolean = true): void {
    const newError = error as Error;

    let transactionName = `${file} - ${method}`;
    if (file === 'baseQuery' && Array.isArray(args) && args.length !== 0 && typeof args[0] === 'string') {
      transactionName = `${file} - ${removeUUIDsFromUrl(args[0])}`;
    }

    console.error(`Error in ${transactionName}:`, newError, {
      arguments: args,
      tags: {
        errorType: typeof error,
        file,
        method,
        type,
        errorShown,
      },
    });
  }

  public logMessage(message: string, level: 'info' | 'error' = 'info', data?: object): void {
    if (data) {
      console[level](`Message: ${message}`, { data });
      return;
    }
    console[level](message);
  }

  public async withTransactionLog<P>(promise: Promise<P>, name: string): Promise<P> {
    return promise;
  }
}

export default new ErrorLogService();
